import React, {useState, useEffect} from 'react';
import {motion, AnimatePresence} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import {FiMenu, FiX} from 'react-icons/fi';
import {Link, useLocation, useNavigate} from 'react-router-dom';

const BOOKING_URL = 'https://links.myvoicelocal.com/widget/bookings/10-minute-call-with-stu';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (id) => {
    setIsMobileMenuOpen(false);
    if (!isHome) {
      navigate('/');
      setTimeout(() => document.getElementById(id)?.scrollIntoView({behavior: 'smooth'}), 100);
    } else {
      document.getElementById(id)?.scrollIntoView({behavior: 'smooth'});
    }
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${isScrolled || isMobileMenuOpen ? 'py-3 md:py-4' : 'py-5 md:py-7'}`}>
      <div className={`mx-4 sm:mx-8 lg:mx-16 rounded-2xl transition-all duration-500 ${isScrolled || isMobileMenuOpen ? 'glass shadow-xl shadow-stone-900/10' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="flex justify-between items-center h-14 md:h-16">
            <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center gap-3 group">
              <div className="w-9 h-9 rounded-xl bg-stone-900 flex items-center justify-center shadow-lg">
                <span className="text-amber-400 font-bold text-lg font-serif">M</span>
              </div>
              <span className="font-semibold text-xl text-stone-900 tracking-tight font-serif">
                MyMD <span className="font-light text-stone-400 italic">Weight Loss</span>
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-10">
              {['how-it-works', 'the-program', 'faq'].map((id) => (
                <button key={id} onClick={() => handleNavClick(id)} className="text-stone-600 hover:text-amber-700 transition-colors text-xs uppercase tracking-widest font-bold">
                  {id === 'the-program' ? 'The Program' : id === 'how-it-works' ? 'How It Works' : 'FAQ'}
                </button>
              ))}
            </div>

            <motion.a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{scale: 1.03}}
              whileTap={{scale: 0.97}}
              className="hidden md:flex items-center gap-2 bg-stone-900 text-white px-6 py-3 rounded-full font-bold text-sm hover:bg-amber-700 transition-all shadow-lg shadow-stone-900/20"
            >
              Apply Now
            </motion.a>

            <button className="md:hidden text-stone-900 p-1.5 z-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
              <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>

        <AnimatePresence>
          {isMobileMenuOpen && (
            <motion.div
              initial={{opacity: 0, height: 0}}
              animate={{opacity: 1, height: 'auto'}}
              exit={{opacity: 0, height: 0}}
              className="md:hidden overflow-hidden border-t border-stone-200/50"
            >
              <div className="px-5 py-6 flex flex-col gap-5">
                {['how-it-works', 'the-program', 'faq'].map((id) => (
                  <button key={id} onClick={() => handleNavClick(id)} className="text-stone-700 text-sm uppercase tracking-widest font-bold text-left py-1.5">
                    {id === 'the-program' ? 'The Program' : id === 'how-it-works' ? 'How It Works' : 'FAQ'}
                  </button>
                ))}
                <a
                  href={BOOKING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-stone-900 text-white px-6 py-4 rounded-full font-bold text-sm mt-2 text-center"
                >
                  Apply for Consultation
                </a>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default Navbar;